import { SCHEDULE_FIELDS_KEYS } from "./constants";

export function isScheduleField(field) {
	return SCHEDULE_FIELDS_KEYS.includes(field);
}